export default "__VITE_ASSET__hSwOvhwk__"